import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router-dom';
import clinicService from '../../../../../services/clinic.service';
import Loading from '../../../../common/Loading';
import MediaListItem from './MediaListItem';
import {List} from '@mui/material'
import Uploader from './Uploader';
const MediaTab = () => {
    const {clinicId} = useParams()
    const [mediaList,setMediaList] = useState([])
    const [loading, setLoading] = useState(false)
    useEffect(()=>{
       updateMediaList()
    },[])

    const updateMediaList  = ()=>{
        setLoading(true)
        clinicService.getMedia(clinicId)
        .then(res=>{
            setLoading(false)
           // console.log(res)
            setMediaList(res.data)
        })
        .catch(err =>{
           // console.log(err)
            setLoading(false)
        })
    }
    return ( 
        <>
             <h5 className="card-title" style={{ color: "#012970" }}>
                  Media
            </h5>
            <Uploader updateMediaList={updateMediaList} />
           {loading?<Loading/>:<>
                <List sx={{width:'100%'}} >
                {mediaList.map((item)=>(
                        <MediaListItem key={item.id} item={item} updateMediaList={updateMediaList}/>
                ))}
                </List>
               
           </>}
        </>
     );
}
 
export default MediaTab;